import { Award, Users, GraduationCap, Heart, Shield, ClipboardCheck } from "lucide-react";

const HEADSHOT = "/dr-greenspan-new.png";
const CASUAL_PHOTO = "/dr-greenspan.jpg";

const credentials = [
  {
    icon: Users,
    title: "Family of Chiropractors",
    detail: "Father, brother & sister — all DCs",
  },
  {
    icon: Shield,
    title: "Previous Western District President",
    detail: "North Carolina Chiropractic Association",
  },
  {
    icon: ClipboardCheck,
    title: "Chiropractic Advisory Board",
    detail: "BC/BS Managed Health Care",
  },
  {
    icon: Award,
    title: "Most Outstanding Organic Chemistry Student",
    detail: "UNCA, 1988",
  },
  {
    icon: GraduationCap,
    title: "Class Salutatorian",
    detail: "Chiropractic Graduate School",
  },
  {
    icon: Heart,
    title: "Extremity Adjusting Training",
    detail: "Under Dr. Kevin Herron, DC, CCSP — Life College of Chiropractic",
  },
];

export default function About() {
  return (
    <section id="about" className="py-24 lg:py-32 bg-[#F7F5F0]" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section label */}
        <p className="font-body text-xs tracking-[0.2em] uppercase font-bold text-[#C87B5D] mb-4">
          The Story
        </p>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-medium text-[#1A221E] tracking-tight leading-none mb-16">
          A Practice Built on Family,<br className="hidden sm:block" /> Passion & Science
        </h2>

        {/* Bento grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Story card - spans 2 cols */}
          <div
            className="lg:col-span-2 bg-white rounded-3xl border border-[#E4DCCF] overflow-hidden transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg"
            data-testid="about-story-card"
          >
            <div className="flex flex-col md:flex-row">
              {/* Photo */}
              <div className="md:w-2/5 h-64 md:h-auto overflow-hidden flex-shrink-0">
                <img
                  src={HEADSHOT}
                  alt="Dr. Kevin Greenspan"
                  className="w-full h-full object-cover object-[center_30%]"
                />
              </div>
              <div className="p-8 lg:p-10 md:w-3/5">
                <h3 className="font-heading text-2xl sm:text-3xl font-medium text-[#3A4F41] tracking-tight mb-6">
                  The Comeback
                </h3>
                <p className="font-body text-base text-[#5C6A61] leading-relaxed mb-4">
                  I stepped away from full-time practice for several years after many successful years in the rapidly growing mountain town of Black Mountain, NC. Then a friend — a fellow chiropractor recovering from surgery — asked me to fill in for a few weeks.
                </p>
                <p className="font-body text-base text-[#5C6A61] leading-relaxed mb-4">
                  That was all it took. I remembered why I fell in love with this work in the first place. The ability to help people heal, to use applied kinesiology to find what their body truly needs — it reignited something I thought I'd put behind me.
                </p>
                <p className="font-body text-base text-[#1A221E] leading-relaxed font-medium">
                  Now I'm back — two days a week — at <strong>Earth Heart</strong> health food store, 4573 US 221 N, Marion, NC 28752.
                </p>
              </div>
            </div>
          </div>

          {/* Family legacy card */}
          <div
            className="bg-[#3A4F41] rounded-3xl overflow-hidden text-white transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg"
            data-testid="about-legacy-card"
          >
            <div className="h-56 overflow-hidden">
              <img
                src="/family-chiropractors.jpg"
                alt="The Greenspan family of chiropractors"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-8">
              <h3 className="font-heading text-2xl font-medium tracking-tight mb-4">
                A Family Legacy
              </h3>
              <p className="font-body text-sm text-white/80 leading-relaxed">
                Chiropractic runs deep in the Greenspan family. I bought my father's practice, and both my brother and sister are chiropractors too. This isn't just a profession — it's a calling that runs through our family.
              </p>
            </div>
          </div>
        </div>

        {/* Credentials row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
          {credentials.map((cred, i) => (
            <div
              key={i}
              className="bg-white rounded-3xl border border-[#E4DCCF] p-6 transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg"
              data-testid={`credential-card-${i}`}
            >
              <div className="w-10 h-10 rounded-full bg-[#C87B5D]/10 flex items-center justify-center mb-4">
                <cred.icon size={18} className="text-[#C87B5D]" />
              </div>
              <h4 className="font-heading text-lg font-medium text-[#1A221E] tracking-tight leading-snug mb-1">
                {cred.title}
              </h4>
              <p className="font-body text-sm text-[#5C6A61]">{cred.detail}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
